export default {"src":"/_next/static/media/with-love.c9e10a69.svg","height":506,"width":685};